import { updateIsSuggestionSetCompleteInternal } from '../actions/internalActions';
import { getStore } from '../store/store';
import { mutator } from 'satcheljs';
export default mutator(updateIsSuggestionSetCompleteInternal, function (actionMessage) {
    var currentSuggestions = getStore().currentSuggestions;
    currentSuggestions.IsComplete = actionMessage.isComplete;
});
//# sourceMappingURL=updateIsSuggestionSetCompleteMutator.js.map